__turbopack_context__.v({
  "controls": "cookie-consent-module-scss-module__vyV7xW__controls",
  "cookie_consent_trigger": "cookie-consent-module-scss-module__vyV7xW__cookie_consent_trigger",
  "dialog_content": "cookie-consent-module-scss-module__vyV7xW__dialog_content",
  "dialog_header": "cookie-consent-module-scss-module__vyV7xW__dialog_header",
  "dialog_panel_content": "cookie-consent-module-scss-module__vyV7xW__dialog_panel_content",
  "dialog_title": "cookie-consent-module-scss-module__vyV7xW__dialog_title",
  "inline_button": "cookie-consent-module-scss-module__vyV7xW__inline_button",
  "label": "cookie-consent-module-scss-module__vyV7xW__label",
  "labels": "cookie-consent-module-scss-module__vyV7xW__labels",
  "link": "cookie-consent-module-scss-module__vyV7xW__link",
  "root": "cookie-consent-module-scss-module__vyV7xW__root",
});
